// extracted by mini-css-extract-plugin
export default {"tabHeader":"CLYch3Bvl_TTmH1mvg90"};